import avatar from './avatar';
import avatargroup from './avatargroup';
import badge from './badge';
import button from './button';
import checkbox from './checkbox';
import Column from './column';
import confirmdialog from './confirmdialog';
import DataTable from './datatable';
import datepicker from './datepicker';
import iconfield from './iconfield';
import inputgroup from './inputgroup';
import inputotp from './inputotp';
import inputtext from './inputtext';
import multiselect from './multiselect';
import Paginator from './paginator';
import progressbar from './progressbar';
import radiobutton from './radiobutton';
import select from './select';
import skeleton from './skeleton';
import slider from './slider';
import tab from './tab';
import tablist from './tablist';
import tag from './tag';
import textarea from './textarea';
import toggleswitch from './toggleswitch';
import tooltip from './tooltip';

export default {
    confirmdialog,
    iconfield,
    button,
    tablist,
    tab,
    radiobutton,
    checkbox,
    toggleswitch,
    textarea,
    inputtext,
    DataTable,
    Column,
    Paginator,
    select,
    skeleton,
    datepicker,
    inputotp,
    multiselect,
    badge,
    avatar,
    avatargroup,
    tag,
    progressbar,
    slider,
    inputgroup,
    tooltip
};
